import { useEffect, useRef, useState, useTransition } from 'react';

import { fetchAvailableSection, saveAllAllowed } from '~modules/section/api';
import { SectionDto } from '~modules/section/model';

export function useLoadAvailableSections() {
	const [list, setList] = useState<SectionDto[]>([]);
	const [isPending, startTransition] = useTransition();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			startTransition(async () => {
				const data = await fetchAvailableSection();
				setList(data);
			});
		}
	}, []);

	const changeAllAllowed = (id: number, value: boolean) => {
		setList(list.map(itm => (itm.id === id ? { ...itm, is_all_allowed: value } : itm)));
		saveAllAllowed(id, value);
	};

	return { list, isPending, changeAllAllowed };
}
